import { useNavigate } from 'react-router-dom';

import { ButtonContainer, Group, IconArrow } from './Wrappers';
import Text from './Text';
import { IconSpeed } from '../Icons/IconSpeed';
import { useApp } from '../../contexts/AppContext';
import { getSpeedLevel } from '../../lib/farming/util';
import { useTranslation } from 'react-i18next';

const Speed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { app } = useApp();

  const level = getSpeedLevel(app);
  const canUp = app.config.speedLevels.length > app.state.speedLevel;

  return (
    <ButtonContainer onClick={() => canUp && navigate('/boost/speed')}>
      <Group>
        <IconSpeed />
        <Text
          heading={t('boosts.speed.physicalStrength')}
          level={t('system.levelShort') + ` ${app.state.speedLevel}/${app.config.speedLevels.length}`}
          reward={`${level.speed} ${t('boosts.speed.coinsPerSec')}`}
        />
      </Group>
      {canUp && <IconArrow />}
    </ButtonContainer>
  );
};

export default Speed;
